// src/pages/Auth/index.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, message, Divider, Avatar } from 'antd'; // 添加了Avatar导入
import { 
  UserOutlined, 
  LockOutlined, 
  MailOutlined,
  GithubOutlined,
  GoogleOutlined 
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import './index.css';

function Auth() {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    
    try {
      const result = await login(values.email, values.password);
      
      if (result.success) {
        form.resetFields();
        navigate('/');
      }
    } catch (error) {
      console.error('登录错误:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = async (email) => {
    setLoading(true);
    try {
      const result = await login(email, 'demo123');
      if (result.success) {
        navigate('/');
      }
    } catch (error) {
      message.error('演示登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <Card className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">欢迎来到博客</h1>
            <p className="auth-subtitle">分享你的想法，发现更多精彩</p>
          </div>
          
          <Form
            form={form}
            name="auth-form"
            onFinish={onFinish}
            size="large"
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: '请输入邮箱地址' },
                { type: 'email', message: '请输入有效的邮箱地址' }
              ]}
            >
              <Input 
                prefix={<MailOutlined />} 
                placeholder="邮箱地址" 
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="密码"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                className="auth-button"
              >
                登录 / 注册
              </Button>
            </Form.Item>
          </Form>

          <Divider plain>或</Divider>

          <div className="social-login">
            <Button 
              icon={<GithubOutlined />} 
              block 
              size="large"
              className="social-button github"
            >
              使用 GitHub 登录
            </Button>
            <Button 
              icon={<GoogleOutlined />} 
              block 
              size="large"
              className="social-button google"
              style={{ marginTop: 12 }}
            >
              使用 Google 登录
            </Button>
          </div>

          <Divider plain>演示账户</Divider>

          <div className="demo-accounts">
            <div className="demo-account" onClick={() => handleDemoLogin('pigStar@gmail.com')}>
              <Avatar size={32} style={{ backgroundColor: '#4361ee' }}>P</Avatar>
              <div className="demo-info">
                <strong>pigStar</strong>
                <span>pigStar@gmail.com</span>
              </div>
              <Button type="link" size="small" onClick={(e) => {
                e.stopPropagation();
                handleDemoLogin('pigStar@gmail.com');
              }}>体验</Button>
            </div>
            
            <div className="demo-account" onClick={() => handleDemoLogin('test@example.com')}>
              <Avatar size={32} style={{ backgroundColor: '#10b981' }}>T</Avatar>
              <div className="demo-info">
                <strong>testuser</strong>
                <span>test@example.com</span>
              </div>
              <Button type="link" size="small" onClick={(e) => {
                e.stopPropagation();
                handleDemoLogin('test@example.com');
              }}>体验</Button>
            </div>
          </div>

          <div className="auth-footer">
            <p className="terms">
              点击"登录 / 注册"即表示您同意我们的
              <a href="/terms" onClick={(e) => {
                e.preventDefault();
                // 这里可以添加服务条款的跳转逻辑
                message.info('服务条款页面开发中');
              }}>服务条款</a>和<a href="/privacy" onClick={(e) => {
                e.preventDefault();
                // 这里可以添加隐私政策的跳转逻辑
                message.info('隐私政策页面开发中');
              }}>隐私政策</a>
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default Auth;